 const PAY_SLIP_COMPONENT_TYPE = {
  ATTENDANCE: "Attendance",
  NET_PAY: "Net Pay",
  DEDUCTION: "Deduction",
  EARNING: "Earning",
};
 const PAYROLL_STATUS = {
  PENDING: "Pending",
  GENERATED: "Generated",
  PUBLISHED: "Published",
};
 const SALARY_COMPONENT_TYPES = {
  DEDUCTION: 1,
  EARNING: 2,
  CONTRIBUTIONS: 3,
    CTC: 4,
  ATTENDANCE: 5,
  TDS : 6,
  
};
 const CALCUATION_FROM_VALUES = {
  BASE: 1,
  CTC: 2
}
 const STATUTORY_COMPONENT_TYPE = {
  ESI: 1,
  EPF: 2,
  LWF: 3,
  PT: 4,
  TDS: 5,
  OTHER: 6
}
 const SALARY_COMPONENT_CALCULATION = {
  FIXED_AMOUNT: 1,
  PERCENTAGE: 2,
  AUTO_CALCULATED: 5
};

export {
  PAY_SLIP_COMPONENT_TYPE,
  PAYROLL_STATUS,
  SALARY_COMPONENT_TYPES,
  CALCUATION_FROM_VALUES,
  SALARY_COMPONENT_CALCULATION,
  STATUTORY_COMPONENT_TYPE,
};